export default {
    accessToken: null,
    refreshToken: null,
    isLogged: false,
}
